import Vue from 'vue';
import Router from 'vue-router';
import LoginForm from '@/views/LoginForm';
import NotFound from '@/views/NotFound';
import Pendentes from '@/views/pendentes/List';
import Proximas from '@/views/proximas/List';
import Pessoal from '@/views/pessoal/List';
import Cliente from '@/views/cliente/List';
import Configuracoes from '@/views/configuracoes/Main';

Vue.use(Router);

export default new Router({
    routes: [
        { path: '*', redirect: '/404' },
        {
            path: '/404',
            component: NotFound
        },
        {
            path: '/login',
            name: 'Login',
            component: LoginForm
        },
        {
            path: '/logout',
            name: 'Logout'
        },
        {
            path: '/configuracoes',
            name: 'Configuracoes',
            component: Configuracoes
        },
        {
            path: '/',
            name: 'Inicio',
            component: Pendentes
        },
        {
            path: '/pendentes',
            name: 'Pendentes',
            component: Pendentes
        },
        {
            path: '/proximas',
            name: 'Proximas',
            component: Proximas
        },
        {
            path: '/pessoal',
            name: 'Pessoal',
            component: Pessoal
        },
        {
            path: '/cliente/*',
            name: 'Cliente',
            component: Cliente
        }
    ]
});